/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Developer_IcInputs */

const cs_projects_developer_ic = /** @type {(inputs: Projects_Developer_IcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IČ developera`)
};

const en_projects_developer_ic = /** @type {(inputs: Projects_Developer_IcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developer IČ`)
};

/**
* | output |
* | --- |
* | "Developer IČ" |
*
* @param {Projects_Developer_IcInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_developer_ic = /** @type {((inputs?: Projects_Developer_IcInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Developer_IcInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_developer_ic(inputs)
	return cs_projects_developer_ic(inputs)
});